import { createSlice } from "@reduxjs/toolkit";

let storedUser = null;

try {
  const userFromStorage = localStorage.getItem("user");
  storedUser = userFromStorage ? JSON.parse(userFromStorage) : null;
} catch (error) {
  console.error("Failed to parse user from localStorage:", error);
  localStorage.removeItem("user");
  storedUser = null;
}

const initialState = {
  user: storedUser,
  isAuthenticated: !!storedUser,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      localStorage.setItem("user", JSON.stringify(action.payload));
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      localStorage.removeItem("user");
    },
    profileUpdate: (state, action) => {
      state.user = action.payload;
      localStorage.setItem("user", JSON.stringify(action.payload));
    },
  },
});

export const { loginSuccess, logout, profileUpdate } = authSlice.actions;
export default authSlice.reducer;